module.exports = __webpack_public_path__ + "img/fig01.dfa071ee.jpg";